import { Close } from '../../../modules/design-system';
import { HeaderPillButton } from './HeaderPillButton';

export interface LobbyPillProps {
  onClick?: () => void;
  label?: string;
}

/**
 * "Back to lobby" pill — rendered only when the casino passed a `lobby_url`
 * at session launch. Same glass shell as {@link MyPacksPill}; icon-only
 * below 600px, X + label from 600px up. Sleek shows an X, not a back
 * chevron: to the player the game is a sheet they close, not a page they
 * leave.
 */
export function LobbyPill({ onClick, label = 'Lobby' }: LobbyPillProps) {
  return (
    <HeaderPillButton onClick={onClick} ariaLabel="Back to lobby" className="w-10 @[600px]:w-auto @[600px]:px-4">
      <Close size={18} />
      <span className="hidden @[600px]:inline">{label}</span>
    </HeaderPillButton>
  );
}
